export default "__VITE_ASSET__bjhAFHss__"